<div class="container-fluid utility">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <span class="ma__decorative-link">
                    <a href="https://www.mass.gov/orgs/massachusetts-environmental-policy-act-office"
                        class="js-clickable-link" target="_blank" aria-hidden="false"
                        title="Massachusetts Environment Policy Act (MEPA) - Opens in a new window"
                        style="text-align: left;" rel="noopener">
                        Mass.gov | Massachusetts Environment Policy Act (MEPA)&nbsp;
                        <!--</span>-->
                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="17" height="16" viewBox="0 0 17 16" aria-labelledby="externalLink" role="link">
                            <title id="externalLink">Open in External window link.</title>
                            <desc>Open in External window.</desc>
                            <defs></defs>
                            <path fill="#fff"
                                d="M739.199 92.7986L739.199 80L735.9989999999999 80L735.9989999999999 95.9983L751.9979999999999 95.9983L751.9979999999999 92.7986ZM743.294 81.0032L743.305 83.5605L746.6049999999999 83.5737L742.9939999999999 87.1849L744.809 89.0001L748.4259999999999 85.3836L748.4399999999999 88.6956L750.997 88.7058L750.976 83.59129999999999L750.966 81.03389999999999L748.409 81.02349999999998L748.409 81.02369999999999Z "
                                transform="matrix(1,0,0,1,-735,-80)"></path>
                        </svg>
                </a>
                </span>
            </div>
            <div class="col-md-6 utility-text">An official application of the Commonwealth of Massachusetts</div>
        </div>
    </div>
</div>